/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Stat_Recovery_SlowInputs */

const en_ui_stat_recovery_slow = /** @type {(inputs: Ui_Stat_Recovery_SlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slow recovery`)
};

const de_ui_stat_recovery_slow = /** @type {(inputs: Ui_Stat_Recovery_SlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsame Erholung`)
};

/**
* | output |
* | --- |
* | "Slow recovery" |
*
* @param {Ui_Stat_Recovery_SlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_stat_recovery_slow = /** @type {((inputs?: Ui_Stat_Recovery_SlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Stat_Recovery_SlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_stat_recovery_slow(inputs)
	return de_ui_stat_recovery_slow(inputs)
});